// vim: set ts=2 sts=2 sw=2 et:

import React from "react";

import type { WrpfSponsor } from "../handoff/types";

interface Props {
  sponsors: ReadonlyArray<WrpfSponsor>;
  perPage?: number;
  intervalMs?: number;
  className?: string;
  tileClassName?: string;
}

// Rota los sponsors de a páginas para darle a cada logo tamaño y tiempo en pantalla.
const SponsorRotator = ({ sponsors, perPage = 1, intervalMs = 6000, className, tileClassName }: Props) => {
  const pageCount = Math.max(1, Math.ceil(sponsors.length / perPage));
  const [page, setPage] = React.useState(0);

  React.useEffect(() => {
    if (pageCount <= 1) return undefined;
    const timer = window.setInterval(() => setPage((current) => (current + 1) % pageCount), intervalMs);
    return () => window.clearInterval(timer);
  }, [intervalMs, pageCount]);

  const visible = sponsors.slice(page * perPage, page * perPage + perPage);
  return (
    <div className={className} aria-label="Sponsors del torneo">
      {visible.map((sponsor) => (
        <div key={`${page}-${sponsor.name}`} className={tileClassName}>
          <img src={sponsor.logoUrl} alt={sponsor.name} />
        </div>
      ))}
    </div>
  );
};

export default SponsorRotator;
